import * as React from 'react';
import { renderText } from '../../../bereiche/dateneingabe/assistent/assistent_helpers';
import { Sitemap } from './Sitemap';

interface StartseiteProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
}

export class Startseite extends React.Component<StartseiteProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element[] {
        return [
            <div key='text' style={{ padding: 10 }}>
                {renderText('Startseite - Adminbereich', this.props.data)}
            </div>,
            <Sitemap
                key='sitemap'
                data={this.props.data}
                onRoutingChange={this.props.onRoutingChange}
            />
        ];
    }
}
